import { Selector } from '../StoreConfig';
import {  } from './types';

export const selectIsAuthenticated: Selector<boolean> = (state) => {
  return state.microsoftGraph.isAuthenticated;
};
